/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Gsm_MissingInputs */

const cs_sreality_seller_gsm_missing = /** @type {(inputs: Sreality_Seller_Gsm_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybí mobil. Vyplňte ho zde, nebo nejdřív nastavte veřejný telefon u uživatele / v profilu.`)
};

const en_sreality_seller_gsm_missing = /** @type {(inputs: Sreality_Seller_Gsm_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile is required. Enter it here, or set the user’s public phone on their profile first.`)
};

/**
* | output |
* | --- |
* | "Mobile is required. Enter it here, or set the user’s public phone on their profile first." |
*
* @param {Sreality_Seller_Gsm_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_gsm_missing = /** @type {((inputs?: Sreality_Seller_Gsm_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Gsm_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_gsm_missing(inputs)
	return cs_sreality_seller_gsm_missing(inputs)
});